import firebase from "./firebase";
import fb from "firebase/app";

const firestore = firebase.firestore();

export const getDetailClient = async (id) =>
  await firestore
    .collection("companies")
    .doc(id)
    .get();


export const updateCompany = async (id, data) => {
  await firestore
    .collection("companies")
    .doc(id)
    .update({
      ...data,
      updatedAt: fb.firestore.FieldValue.serverTimestamp(),
    });
}
